import { Action, Dispatch } from "redux";
import { AxiosError } from "axios";

export const unauthenticatedRedirectMiddleware = () => (next: Dispatch) => async (action: Action) => {

    try {
        return await next(action);
    } catch (e) {
        const axiosError = e as AxiosError;
        if (axiosError.response && axiosError.response.status === 401) {
            location.href = `/account/signin?redirectUrl=${location.href}`;
        }
        throw e;
    }
};
